import { Pallet_t, Layout_t, Box_t } from "blackbox";
import { UnitsSystem } from "libapi";
import { useMemo } from "react";
import { useContainerSize } from "../../../shared/shared";
import { SummaryItemCell } from "../../Shared";
import { LayoutModelProps, LayoutModel } from "../canvas/LayoutModel";

export interface LayoutCellProps {
	pallet: Pallet_t;
	layout: Layout_t;
	startEdit: () => void;
	deleteLayout: () => void;
  duplicateLayout: () => void;
	allBoxes: Box_t[];
	unitsSystem: UnitsSystem;
}

export function LayoutCell({
	layout,
	pallet,
	startEdit,
	deleteLayout,
  duplicateLayout,
	allBoxes,
	unitsSystem,
}: LayoutCellProps) {
	const { ref: lContainerRef, rect: lContainerRect } =
		useContainerSize<HTMLDivElement>(),
		lSize = useMemo(
			function () {
				if (!lContainerRect) return 0;
				return Math.min(lContainerRect.height, lContainerRect.width);
			},
			[lContainerRect]
		),
		{ name, boxPositions } = layout,
		model_props: LayoutModelProps = {
			pallet,
			size: lSize,
			boxes: boxPositions,
			allBoxes,
			unitsSystem: unitsSystem,
			snapStrength: 0,
      overhang: layout.overhang
		},
		formatNameDetails = () => {
			const lNumBoxes = layout.boxPositions.length;
			const lPlural = lNumBoxes === 1 ? 'Box' : 'Boxes';
			return `${lNumBoxes} ${lPlural} (${pallet.name})`;
		};
	return (
		<SummaryItemCell
			name={name}
			properties={formatNameDetails()}
			trashAction={deleteLayout}
			editAction={startEdit}
      duplicateAction={duplicateLayout}
		>
			<div className="full-size flex-center flex-col" ref={lContainerRef}>
				{lContainerRect && <LayoutModel {...model_props} />}
			</div>
		</SummaryItemCell>
	);
}